// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#createEditOrganization[data-v-655e509d]{color:#999;padding:0px 30px}.modal-container[data-v-655e509d]{display:block;padding-left:10px}.invisible[data-v-655e509d]{display:none}input[type=\"file\"][data-v-655e509d]{display:none}.subNote[data-v-655e509d]{color:#999}.logoSize[data-v-655e509d]{color:#e03030;text-align:right}.logoSizeOk[data-v-655e509d]{color:#509050 !important}.licenseNumberInput[data-v-655e509d]{display:inline-block;margin:0px 10px 10px 0px}\n", ""]);
// Exports
module.exports = exports;
